import React, { Component } from "react";
import {
  Col,
  Row
} from "reactstrap";
import { connect } from "react-redux";
import { Alert } from "reactstrap";

import { SlPageTitle, SlFormEntryRow, SlYesNo, SlSectionLabel, SlButton } from "../editors"
import Stepper from "./Stepper";
import { registrationActions } from "../../_actions";
import { metadataService, AccountAPI } from "../../_services"
import { MfaValidation } from "./MfaValidation";
import { registrationConstants } from '../../_constants';
import { history   } from "../../_helpers";

class SignUpOptInValidation extends Component {
  static displayName = SignUpOptInValidation.name;

  constructor(props) {
    super(props);
    this.state = {
      formValue: {
        mobileOptIn: 'true'
      },
      textisOptIn: this.props.textisOptIn,
      textisOptOut: this.props.textisOptOut,
      textOptInError: false,
      textValidationTokenIdError: false,
      codeToPhoneError: false,
      phoneCodeIsValidError: false,
      formError: false
    };

    this.handleInput = this.handleInput.bind(this);
    this.handleSubmitOptOut = this.handleSubmitOptOut.bind(this);
    this.handleMfaConfirmed = this.handleMfaConfirmed.bind(this);
  }
  componentDidMount() {
    if(!this.props.completedSteps.find(t => t === registrationConstants.SEND_EMAIL_CODE_RESPONSE)){
        history.push("/SignUpEmailValidation")
    }
}

  handleInput = ({ target: { name, value } }) => {
    
    const formValue = { ...this.state.formValue, [name]: value };
    this.setState({ formValue });
  };

  handleSubmitOptOut = () => {
    const { dispatch } = this.props;

    dispatch(registrationActions.handleTextOptOutRequest());
  };

  handleMfaConfirmed = (token) => {
    const { dispatch } = this.props;

    dispatch(registrationActions.handleConfirmOptIn(token, this.props.email));     
  }

  render() {
    const { error } = this.props;
    const { formError } = this.state;

    return (
      <div className="SignUpOptInValidation">
         {this.props.steps.length > 0 && (
                    <Stepper stepData={this.props.steps} currentStep={this.props.currentStep} />
                )}
        <SlPageTitle pageName="MobileConfirmation" />                
        <div id="LogInFailed">
          <Row className="justify-content-center">
            {(error || formError) && (
              <Col xs={12} md={6}>
                <Alert color="danger">
                  <div id="failure">
                    <p>An Error Occured on the page</p>
                  </div>
                </Alert>
              </Col>
            )}
          </Row>
        </div>
        <div id="optIn">
          <Row className="p-3 m-3 justify-content-center">
            <Col sm={12}>
              <SlSectionLabel centered={false} sectionName='PhoneNotificationLabel'/>
            </Col>
          </Row>
          
          <SlFormEntryRow>
            <div >
              <SlYesNo falseText={metadataService.getLabel('No')} trueText={metadataService.getLabel("Yes")} 
                trueValue={true} falseValue={false} name='mobileOptIn' value={this.state.formValue.mobileOptIn==='true'} 
                onChange={this.handleInput}
              />
            </div>
          </SlFormEntryRow>

          {this.state.formValue.mobileOptIn ==='false' && (
            <SlFormEntryRow>
              <div className="text-center">
              <SlButton size="lg" name="Next" onClick={this.handleSubmitOptOut}/>
              </div>
            </SlFormEntryRow>
          )}
        </div>
        {this.state.formValue.mobileOptIn === 'true' && (
          <MfaValidation mode='optin' mobileNumber={this.props.mobileNumber} mfaReason={AccountAPI.MFA_REASON_VALIDATE_USER} 
          mfaConfirmed={this.handleMfaConfirmed}/>
          )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { loggedIn } = state.authentication;
  const {
    existingCustomer,
    error,
    errorString, 
    mobileNumber,
    email, 
    textisOptIn,
    textisOptOut,
    textValidationTokenId, 
    completedSteps
  } = state.registration;
  const { steps, currentStep } = state.users;
  return {
    loggedIn,
    existingCustomer,
    error,
    errorString, 
    mobileNumber,
    email,
    textisOptIn,
    textisOptOut,
    textValidationTokenId, 
    completedSteps,
    steps, 
    currentStep,
  };
}

const connectedSignUpOptInValidation = connect(mapStateToProps)(
  SignUpOptInValidation
);
export { connectedSignUpOptInValidation as SignUpOptInValidation };



// WEBPACK FOOTER //
// ./src/components/subcomponents/SignUpOptInValidation.js